import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, NgZone } from "@angular/core";
import { EventManager } from "@angular/platform-browser";
import { Observable } from "rxjs";

type Options = {
    element: any;
    keys: string;
    url:string;
  }
  
  @Injectable({ providedIn: 'root' })
  export class HotkeysService {
    defaults: Partial<Options> = {
      element: this.document
    }
      
    constructor(private eventManager: EventManager,
                @Inject(DOCUMENT) private document: Document,
                private ngZone: NgZone ) {
    }
  
    addShortcut(options: Partial<Options>) {
      const merged = { ...this.defaults, ...options };
      const event = `keydown.${merged.keys}`;
  
      return new Observable(observer => {
        const handler = (e) => {
          e.preventDefault();
          observer.next({event:e, merged: merged});
        };
        let dispose: any;

        this.ngZone.runOutsideAngular(() => {
          dispose = this.eventManager.addEventListener(
            merged.element, event, handler
          );
        });
        return () => {
          dispose();
        };
      })
    }
  }